/** Tag base Commerce Layer che abilita Order on Behalf. */
export const OOB_OPERATOR_TAG = 'order_on_behalf'

/** Prefisso dei tag operatore per-partner (es. "oob_odity"). */
export const OOB_OPERATOR_TAG_PREFIX = 'oob_'

/**
 * Un tag autorizza l'Order on Behalf se è esattamente `order_on_behalf`
 * oppure inizia con `oob_` (tag per-partner, es. "oob_odity").
 * Unica fonte di verità per il matching: usata sia lato server sia nei composables.
 */
export const isOobOperatorTag = (tag: string): boolean =>
  tag === OOB_OPERATOR_TAG || tag.startsWith(OOB_OPERATOR_TAG_PREFIX)

/**
 * Primo tag operatore trovato (usato come `oob_tag` e `utm_campaign`).
 * I tag per-partner `oob_*` hanno priorità sul tag generico, così la campaign
 * resta distinguibile per partner anche quando un operatore ha entrambi.
 */
export const findOobOperatorTag = (tags: string[]): string | null =>
  tags.find(t => t.startsWith(OOB_OPERATOR_TAG_PREFIX)) ??
  tags.find(t => t === OOB_OPERATOR_TAG) ??
  null

/** True se almeno un tag autorizza l'Order on Behalf. */
export const hasOobOperatorTag = (tags: string[]): boolean =>
  tags.some(isOobOperatorTag)
